module.exports = __webpack_public_path__ + "static/sketchapp1-38a830a474068b919c3fb911d1ce4f5a.png";